
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Status } from '@/utils/alertIconStatus'

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class AppAlertIcon extends Vue {
    @Prop({ default: Status.OK }) public status?: Status

    get color(): string {
        switch (this.status) {
            case Status.OK:
                return '#27B042'
            case Status.WARNING:
                return '#F1C232'
            default:
                return '#B00020'
        }
    }

    get icon(): string[] {
        if (this.status === Status.OK) {
            return ['fas', 'check-circle']
        }

        return ['fas', 'exclamation-triangle']
    }

    @Emit('click')
    public onClick(e: Event) {
        e.stopPropagation()
        return e
    }
}
